import React from 'react';
import { Button } from 'react-bootstrap';
import RoleListItem from '../components/collapse';
import FilterRolesModal from '../components/FilterRolesModal';
import { withRouter } from 'react-router-dom';
import Header from "./header";
import Logger from './Logger';
import noty from './Noty';
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import Cookies from 'universal-cookie';
import checkForSession from "./SessionChecker";

const cookies = new Cookies();

class Tasks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allEventsData: [],
            roles: [],
            className: '',
            IsAccepting: '',
            mainHub: props.hub,
            isWaiting: false,
            isShowModal: false,
            checkList: [],
            isPaused: false,
            isUnmount: false
        }
        this.routeChange = this.routeChange.bind(this);
        this.onFilterRolesModalClick = this.onFilterRolesModalClick.bind(this);
        this.hideRolesModal = this.hideRolesModal.bind(this);
        this.handleRolesFilter = this.handleRolesFilter.bind(this);
        this.setIsMount = this.setIsMount.bind(this);
    }

    componentDidMount() {
        this.props.history.location.state == undefined
            ?
            checkForSession(this.props)
            :
            this.initialize();
    }

    componentWillUnmount() {
        this.props.history.goForward();
    }

    initialize() {
        this.simulationPaused();
        this.simulationResumed();
        this.simulationInitialized();
    }

    handleChange = (IsAccepting, isWaiting) => {
        if (IsAccepting === 'False') {
            this.setState({
                className: 'simTasksRequired',
                IsAccepting,
                isWaiting
            })
        }
        else {
            this.setState({
                className: 'simProcessCompleted',
                IsAccepting,
                isWaiting
            })
        }
    }

    routeChange() {
        const self = this;
        const {simulationID, token, title, createdBy, pin, isMultiSimulationAllow} = self.props.location.state;
        self.setIsMount(true);
        self.state.mainHub.invoke('CallLeaveSimulation',
        simulationID,
        token,
        isMultiSimulationAllow)
            .then(function (response) {
                let path = "/Feedback/";
                self.props.history.push({
                    pathname: path,
                    state: {
                        token: token,
                        title: title,
                        createdBy: createdBy,
                    }
                });
                self.setCookie(pin)
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Failed to leave public simulation.', error.message, error.stack, 'Error');
            });
    }

    setCookie(pin) {
        let cookieArray = [];
        let cookie = cookies.get('SimCookie');
        if (cookie != undefined) {
            cookie.map(function (o) {
                cookieArray.push('' + o)
            });
            cookieArray.push('' + pin)
        }
        else {
            cookieArray.push('' + pin)
        }
        cookies.set('SimCookie', cookieArray, { path: '/' });
    }

    onFilterRolesModalClick() {
        this.setState({
            isShowModal: true
        })
    }

    hideRolesModal = (modalstate) => {
        this.setState({
            isShowModal: modalstate
        })
    }

    async handleRolesFilter(checkList) {
        await this.setState({
            checkList,
            isShowModal: false
        });
        this.child.filterRoles();
    }

    async simulationPaused() {
        const self = this;
        await self.state.mainHub.on('simulationPaused', async function (message) {
            await self.setState({
                isPaused: true
            })
        });
    }

    async simulationResumed() {
        const self = this;
        await self.state.mainHub.on('simulationResumed', async function (message) {
            await self.setState({
                isPaused: false
            })
        });
    }

    simulationInitialized() {
        this.state.mainHub.on('simulationInitialized', function (message) {
            console.log(" simulationInitialized!");
            window.location.reload();
        });
    }

    setIsMount(isUnmount) {
        this.setState({
            isUnmount: isUnmount
        })
    }

    render() {
        let propsState = this.props.location.state;
        if (propsState == undefined) {
            return null;
        }
        return (
            <div>
                <FilterRolesModal
                    onChange={this.state.isShowModal}
                    hideModal={this.hideRolesModal}
                    hub={this.props.hub}
                    id={propsState.id}
                    checkList={propsState.checkList}
                    filter={this.handleRolesFilter}
                    simulationID={propsState.simulationID}
                />
                <header>
                    <div className="top-header-block">
                        <Header data={propsState} isInput={false} />
                    </div>
                </header>
                <main>
                    <div className="mainBodyBlock">
                        {
                            (this.state.isWaiting && !this.state.isPaused) ?
                                <div>
                                    <div className="main-body-heading-block clearfix">
                                        <div className="allTasksBlock float-left">
                                            <span className="main-text">Tasks</span>
                                        </div>
                                        <div className="filterRolesBlock float-right">
                                            <Button onClick={this.onFilterRolesModalClick} href="#" variant="primary" size="sm"> Filter Roles </Button>
                                        </div>
                                    </div>
                                    <div className="select-all-roles-block custom-control custom-checkbox">
                                        <span className="main-sub-heading">Available Tasks</span>
                                        <span className={'simMoreTasks ' + this.state.className}></span>
                                    </div>
                                </div> :
                                ""
                        }
                        {
                            !this.state.isPaused ?
                                <div className="tasks-list-block clearfix">
                                    <RoleListItem
                                        onChange={this.handleChange}
                                        hub={this.state.mainHub}
                                        filter={this.state.checkList}
                                        onRef={ref => (this.child = ref)}
                                        isUnmount={this.state.isUnmount}
                                    />
                                </div> :
                                <div className="tasks-list-block clearfix">
                                    <div className="main-sub-heading clearfix text-center">
                                        No Tasks Available, Simulation is Paused
                                        </div>
                                </div>
                        }
                        {
                            (this.state.isWaiting && !this.state.isPaused) ?
                                <div className="main-body-heading-block clearfix">
                                    <div className="proceedTasksBlock float-right">
                                        <Button className="proceedTasks" color="success" onClick={() => { if (window.confirm("You are about to leave simulation, you won't be able to join again. Are you sure?")) { this.routeChange() }; }} >Exit</Button>
                                    </div>
                                </div> :
                                ''
                        }

                    </div>
                </main>
            </div>
        );
    }
}
export default withRouter(Tasks);